import { SourcingNodeConfig } from "../../type";
import { SUPPLIER_STAGE } from "@/constants";

// 生产物料寻源节点配置项
export const defaultProductionMaterialSourcingNodes: SourcingNodeConfig[] = [
  {
    nodeCode: "M1",
    nodeName: "物料质量标准确认1",
    fields: [
      {
        type: "upload",
        name: "relatedFiles",
        label: "现有标准物料文件",
        required: false,
      },
      {
        type: "upload",
        name: "newRelatedFiles",
        label: "新标准物料文件（如有）",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        placeholder: "添加描述",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M2",
    nodeName: "供应商开发和筛选",
    fields: [
      {
        type: "supplierSelect",
        name: "supplierId",
        label: "已注册供应商",
        required: true,
        supplierStage: SUPPLIER_STAGE.REGISTRATION,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        placeholder: "添加描述",
        required: false,
      },
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M3",
    nodeName: "供应商选择和评估",
    fields: [
      {
        type: "supplierSelect",
        name: "supplierId",
        label: "已通过评估供应商",
        required: true,
        supplierStage: SUPPLIER_STAGE.EVALUATION,
      },
      {
        type: "input",
        name: "relatedForm",
        label: "关联表单",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        placeholder: "添加描述",
        required: false,
      },
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M4",
    nodeName: "样品小试或中试研究",
    collapsible: false,
    fields: [],
  },
  {
    nodeCode: "M5",
    nodeName: "供应商合格认证（原供应商准入）",
    fields: [
      {
        type: "supplierSelect",
        name: "supplierId",
        label: "已认证合格供应商",
        required: true,
        supplierStage: SUPPLIER_STAGE.ONBOARDING,
      },
      {
        type: "input",
        name: "relatedForm",
        label: "关联表单",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        placeholder: "添加描述",
        required: false,
      },
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
    ],
  },
];

// 非生产物料寻源节点配置项
export const defaultNonProductionMaterialSourcingNodes: SourcingNodeConfig[] = [
  {
    nodeCode: "M1",
    nodeName: "提供URS",
    fields: [
      {
        type: "upload",
        name: "relatedFiles",
        label: "URS文件",
        required: true,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        placeholder: "添加描述",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M2",
    nodeName: "供应商开发和筛选",
    fields: [
      {
        type: "supplierSelect",
        name: "supplierId",
        label: "已注册供应商",
        supplierStage: SUPPLIER_STAGE.REGISTRATION,
        required: true,
      },
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M3",
    nodeName: "用户与供应商技术沟通",
    fields: [
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M4",
    nodeName: "采购与供应商商务沟通",
    fields: [
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M5",
    nodeName: "汇总技术与商务资料",
    fields: [
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
      },
    ],
  },
  {
    nodeCode: "M6",
    nodeName: "采购委员会获批",
    fields: [
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        required: false,
      },
    ],
  },
  {
    nodeCode: "M7",
    nodeName: "合同签署获批",
    fields: [
      {
        type: "supplierSelect",
        name: "supplierId",
        label: "签署供应商",
        required: true,
      },
      {
        type: "upload",
        name: "relatedFiles",
        label: "相关文件",
        required: false,
      },
      {
        type: "input",
        name: "nodeRemarks",
        label: "节点描述",
        required: false,
      },
    ],
  },
];
